import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'
import { Link } from 'react-router-dom'
import Parser from 'html-react-parser'
// Actions
import {
	signInUser,
	checkConsent,
	signInUserSuccess,
	signInUserFailure,
	userConsentSuccess,
	userConsentFailure,
	UpdateAcknowledgement,
	getToken,
	resetError,
	PeriodicValidationPartnersUsers,
	checkPasswordValidity,
	checkNewsLetterAcceptance,
	newsletterAcceptanceSuccess,
	newsletterAcceptanceFailure
} from 'actions/userActions'

import ChangePassword from 'components/Menu/ChangePassword'
import moment from 'moment'

// Components
import Textfield from 'react-mdl/lib/Textfield'
import Button from 'UI/Button'

// Utils
import { BreakLine, getCurrentLanguage } from 'utils/Utils'

// Settings
import { modalStyle, modalContentStyle, routes, validators } from 'Constants'

import Modal from 'reboron/OutlineModal'
import Terms from './Terms'
import NewUpdate from './NewUpdate'
import NewsLetter from './NewsLetter'
import {
	periodicEmailConfirmation,
	periodicEmailConfirmationFailure,
	periodicEmailConfirmationSuccess
} from 'actions/userActions'

// Inline styles for the card – you can also use CSS classes
const cardStyle = {
	backgroundColor: '#ffffff',
	padding: '2rem 2.5rem',
	borderRadius: '8px',
	boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
	maxWidth: '500px',
	margin: '0 auto',
};

class LoginContainer extends Component {
	constructor(props) {
		super(props)

		this.handleSignInUser = this.handleSignInUser.bind(this)
		this.redirect = this.redirect.bind(this)
		this.checkConsent = this.checkConsent.bind(this)
		this.showModal = this.showModal.bind(this)
		this.hideModal = this.hideModal.bind(this)
		this.checkNewsLetterAcceptance = this.checkNewsLetterAcceptance.bind(this)
		this.state = {
			enablePeriodicValidation: false,
			email: '',
			counter: 2,
			lockUser: false,
			isPasswordValid: true,
			isCustomer: false,
			showReactivation: false,
		}
		this.PeriodicEmailConfirmation = this.PeriodicEmailConfirmation.bind(this)
		this.checkPasswordValidity = this.checkPasswordValidity.bind(this)
	}

	handleSignInUser(values) {
		var data = {};
		var content = this.props.content;
		this.setState({ email: values.Email.trim() })
		if (this.state.counter <= 0) {
			this.setState({ lockUser: true })
			data = {
				Email: values.Email.trim(),
				Password: values.Password,
				LockUser: true
			}
		} else {
			data = {
				Email: values.Email.trim(),
				Password: values.Password,
				LockUser: this.state.lockUser
			}
		}

		this.checkPasswordValidity(data)
		this.props.signInUser(data)
			.then((result) => {
				if(result.data.Result.applicationUser) {
					result.data.Result.applicationUser.isCustomer = result.data.Result.isCustomer
				}
				this.props.signInUserSuccess(result);
				// Reset form
				this.formDispatch(actions.reset('signIn'))

				// Store JWT Token
				localStorage.setItem('jwtToken', result.data.Result.applicationUser.Token)
				localStorage.setItem('role', result.data.Result.applicationUser.Role)
				localStorage.setItem('loggedinUser', result.data.Result.applicationUser.Email)
				localStorage.setItem('id', result.data.Result.applicationUser.Id)
				localStorage.setItem('daysRemainforReactivation', result.data.Result.NextPeriodicValidationInDays)
				sessionStorage.setItem('isCustomer', result.data.Result.isCustomer)
				localStorage.setItem('enablementInsightFlag', result.data.Result.enablementFlag)

				if(!this.state.isPasswordValid) {
					this.props.resetError()
					this.showModal("changePassword")					            
				} else {
					this.checkConsent()	            
				}
			}).catch((error) => {
				if (error.message === "Network Error") {
					this.props.signInUserFailure("API service is down. Please contact administrator.")
				}
				else {
					var errorMsg = content[error.response.data.Message];
					this.setState((prevState, props) => ({
						counter: prevState.counter - 1
					}));
					if (this.state.counter < 0) {
						if(error.response.status == "501"){
							var errMsg = content[error.response.status]	
							if(error.response.data.Message !== undefined){						
							localStorage.setItem('LockoutEndDate', error.response.data.Message)
							}
							var lockDate = localStorage.getItem('LockoutEndDate').split("-");	
							this.props.signInUserFailure(errMsg.replace('%Date%', lockDate[1] ))
						}
						else{
							if(error.response.status == 412)
							{
								this.setState({ enablePeriodicValidation: true });
							}
						this.props.signInUserFailure(content[error.response.status]);
						}
					} else if (content[error.response.status] !== undefined && error.response.status !== "501" && errorMsg !== undefined) {
						this.setState({ enablePeriodicValidation: true });
						if(error.response.status == "501"){
							var errMsg = content[error.response.status]		
							if(error.response.data.Message !== undefined){						
							localStorage.setItem('LockoutEndDate', error.response.data.Message)
							}
							var lockDate = localStorage.getItem('LockoutEndDate').split("-");
							
							this.props.signInUserFailure(errMsg.replace('%Date%', lockDate[1] ))
						}else{
							this.props.signInUserFailure(content[error.response.status])	
						}
					} else if (content[error.response.status] !== undefined) {
						this.setState({ enablePeriodicValidation: false });
						this.props.signInUserFailure(content[error.response.status])
					}
					else {
						this.props.signInUserFailure(error.response.data.Message);
					}
				}
			})
	}

	checkConsent() {
		var content = this.props.content;
		const value = {
			UserID: localStorage.getItem('id')
		}		
		this.props.checkConsent(value)
			.then((result) => {
				this.props.userConsentSuccess(result)
				if(!localStorage.getItem('loggedinUser').includes('sap.com') && sessionStorage.getItem('isCustomer') !== 'true')
		     	{
				this.checkNewsLetterAcceptance()
				}
				else{
					this.redirect()
				}
			}).catch((error) => {
				if (error.response.status == 404) {
					this.showModal("terms")
				}
				this.props.userConsentFailure(error.response.data.Message)
			})
	}

	checkNewsLetterAcceptance(){
		const value = {
			UserID: localStorage.getItem('id')
		}		
		this.props.checkNewsLetterAcceptance(value)
			.then((result) => {
				this.setState({ newsLetterCheck : result.data.Result })
				this.props.newsletterAcceptanceSuccess(result)
				this.redirect()
			}).catch((error) => {
				if (error.response.status == 404) {
					this.showModal("newsLetter")
				}
				this.props.newsletterAcceptanceFailure(error.response.data.Message)
			})
	}

	showModal(action) {
		this.refs[action].show()
	}

	hideModal(action) {
		const value = {
			UserID: localStorage.getItem('id'),
			Accepted: true
		}
		this.props.UpdateAcknowledgement(value)
			.then((result) => {
				this.props.userConsentSuccess(result)
				this.redirect()
			}).catch((error) => {
				this.props.userConsentFailure(error.response.data.Message)
			})
		this.refs[action].hide()
	}

	checkPasswordValidity(param){
		const value = {
			UserID: param.Email
		}
		this.props.checkPasswordValidity(value)
			.then((result) => {
				this.props.userConsentSuccess(result)
				this.setState({isPasswordValid : result.data.Result})
			}).catch((error) => {				
				this.props.userConsentFailure(error.response.data.Message)
			})
	}

	redirect() {
		this.props.history.push(`/start`)
	}

	componentDidMount() {

		if (
			this.props.location &&
			this.props.location.state &&
			this.props.location.state.showReactivation
		) {
			this.setState({
				enablePeriodicValidation: true,
				showReactivation: true,
				email: this.props.location.state.email
			});
		}
	}

	componentWillUnmount() {
		this.formDispatch(actions.reset('signIn'))
		this.props.resetError()
	}

	PeriodicEmailConfirmation() {
		let language = getCurrentLanguage()

		if (language === undefined || language === 'undefined' || language === '') {
			language = 'en'
		}
		let values = { Email: this.state.email, Language: language };

		var content = this.props.content

		this.props.periodicEmailConfirmation(values)
			.then((response) => {
				this.setState({ enablePeriodicValidation: false })
				this.props.periodicEmailConfirmationSuccess(content[response.status])
			}).catch((error) => {
				this.props.periodicEmailConfirmationFailure(content[error.response.status])
			})
	}

	render() {
		return (
			<div className="grid-container pt20">
				<div className="grid-x">
					<div className="cell medium-8 large-6" style={cardStyle}>
						<div className="page-title" style={{ marginBottom: '1.5rem' }}>
							{BreakLine(this.props.content.title)}
						</div>
	
						<Form
							model="signIn"
							getDispatch={(dispatch) => this.formDispatch = dispatch}
							method="post" onSubmit={(values) => this.handleSignInUser(values)}
						>
							<Control.text
								model="signIn.Email"
								id="signIn.Email"
								component={Textfield}
								label={this.props.content.email}
								floatingLabel
								validators={{
									required: validators.required,
									validEmail: validators.validEmail
								}}
								validateOn="blur"
							/>
							<Errors
								className="errors"
								model="signIn.Email"
								show="touched"
								messages={{
									validEmail: this.props.validation.validEmail
								}}
							/>
							<Control.text
								model="signIn.Password"
								id="signIn.Password"
								type="password"
								component={Textfield}
								label={this.props.content.password}
								floatingLabel
								validators={{
									required: validators.required
								}}
							/>
							<Errors
								className="errors"
								model="signIn.Password"
								show="touched"
								messages={{
									required: this.props.validation.required
								}}
							/>
	
							{/* 🔥 Hide login button & links when periodic validation is shown */}
							{!this.state.enablePeriodicValidation && (
								<>
									<ul>
										<li><Link to={routes.register}>{this.props.content.register}</Link></li>
										<li><Link to={routes.forgotPassword}>{this.props.content.forgotPassword}</Link></li>
										<li><a href="mailto:sap_ism_value_experience@sap.com">{this.props.content.help}</a></li>
									</ul>
									<br />
									<br />
									<Button
										type="submit"
										disabled={this.props.user.loading}
										content={this.props.content.login}
										color />
									<br />
								</>
							)}
	
							<div className="errors">
								{
									(this.state.enablePeriodicValidation) ?
										<div className="errors">
											{
    this.state.showReactivation
        ? "Your account has been deactivated as per periodic validation. Please click below button to reactivate."
        : this.props.content.periodicErrorMessage
}
<br />
<br />
											<ul>
												<li>
													<Button
														type="button"
														content={
															this.state.showReactivation
																? "Click here to reactivate"
																: Parser(this.props.content.periodicValidationLink)
														}
														onClick={(event) => this.PeriodicEmailConfirmation(event)}
														outline
													/>
												</li>
											</ul>
										</div>
										: <div> {this.props.user.error} </div>
								}
							</div>
						</Form>
					</div>
				</div>
	
				{/* Modals – unchanged */}
				<div>
					<Modal
						ref="terms"
						modalStyle={modalStyle}
						contentStyle={modalContentStyle}>
						<Terms props={this.props.history} buttonVisible ={true} checkNewsLetterAcceptance = {this.checkNewsLetterAcceptance} />
					</Modal>
				</div>
				<div>
					<Modal
						ref="newsLetter"
						modalStyle={modalStyle}
						contentStyle={modalContentStyle}>
						<NewsLetter props={this.props.history} buttonVisible ={true} newsLetterCheck ={ this.state.newsLetterCheck} />
					</Modal>
				</div>
				<div>
					<Modal
						ref="changePassword"
						modalStyle={modalStyle}
						contentStyle={modalContentStyle}>
						<ChangePassword props={this.props.history} />
					</Modal>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		content: state.content.login,
		validation: state.content.validation,
		user: state.default
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		signInUser: (formValues) => dispatch(signInUser(formValues)),
		checkConsent: (formValues) => dispatch(checkConsent(formValues)),
		UpdateAcknowledgement: (formValues) => dispatch(UpdateAcknowledgement(formValues)),
		signInUserSuccess: (user) => dispatch(signInUserSuccess(user)),
		signInUserFailure: (error) => dispatch(signInUserFailure(error)),
		userConsentSuccess: (user) => dispatch(userConsentSuccess(user)),
		userConsentFailure: (error) => dispatch(userConsentFailure(error)),
		getToken: (username) => dispatch(getToken(username)),
		resetError: () => dispatch(resetError()),
		PeriodicValidationPartnersUsers: (email) => dispatch(PeriodicValidationPartnersUsers(email)),
		periodicEmailConfirmation: (email) => dispatch(periodicEmailConfirmation(email)),
		periodicEmailConfirmationSuccess: (bool) => dispatch(periodicEmailConfirmationSuccess(bool)),
		periodicEmailConfirmationFailure: (error) => dispatch(periodicEmailConfirmationFailure(error)),
		checkPasswordValidity: (formValues) => dispatch(checkPasswordValidity(formValues)),
		checkNewsLetterAcceptance: (formValues) => dispatch(checkNewsLetterAcceptance(formValues)),
		newsletterAcceptanceSuccess: (user) => dispatch(newsletterAcceptanceSuccess(user)),
		newsletterAcceptanceFailure: (error) => dispatch(newsletterAcceptanceFailure(error))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)